import React from 'react';
import { Div, Text } from 'components/Atoms';
import { Image, Title, Content } from './styled';

const index = ({ image, title, content }) => {
  return (
    <Div position="relative" width="90%" marginTop="32px">
      <Image src={image}/>
      <Content>
        <Title textAlign="center">{title}</Title>
        <Text textAlign="center" maxWidth="240px" margin="0 auto">{content}</Text>
      </Content>
    </Div>
  )
}

export default index
